



















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SearchBox from '@/libs/search/components/SearchBox.vue';

import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { AuthAction, AuthGetter } from '@/libs/auth/models/auth-state';
import { authStore } from '@/libs/auth/+store/store';
import { applicationUserStore } from '@/libs/user-settings/+state/store';

import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
import { AccountTypeEnum, TenantUserModel, ApplicationUserModel } from '@/libs/Api';
Vue.use(TooltipPlugin);

@Component({
    components: { SearchBox }
})
export default class SidebarMenu extends Vue {

    enableDock = true;
    dockSize = '72px'
    width = '220px';
    position ='Left';
    fields = { tooltip: 'text' };
    linkGroupId: string | null = null;
    mobileNavCollapsed = false;
    tenantMenu = false;
    selectedTenant: string | null = null;
    localeInner: string | null = null;

    @Prop() tenantId!: string;
    @Prop() locale!: string;

    @Watch("tenantId")
    tenantIdChanged (v: string, p: string) {
        if (v != null && v !== p && v != this.$route.params.tenantId) {
            this.selectedTenant = v;
        }
    }

    @Watch("locale")
    localeChanged (v: string, p: string) {
        if (v != null && v !== p) {
            this.localeInner = v;
        }
    }

    @Watch("localeInner")
    localeInnerChanged (v: string, p: string) {
        if (v != null && v !== p) {
            this.$emit("localeChanged", v);
        }
    }

    @Watch("selectedTenant")
    selectedTenantChanged (v: string, p: string) {
        if (v != null && v !== p && v != this.$route.params.tenantId) {
            authStore.dispatch(AuthAction.SetTenant, v);
        }
    }

    get userInfo(): ApplicationUserModel {
        return applicationUserStore.useGetter(CrudGetter.Detail);
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get dataList(): Array<any> {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        if (tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager) {
            return [
                { text: this.$i18n.t("menu.dashboard"), to: { name: 'Dashboard', params: { tenantId: this.tenantId } }, icon: "dashboard.svg" },
                { text: this.$i18n.t("menu.workTasks"), to: { name: 'WorkTasks', params: { tenantId: this.tenantId } }, icon: "work-tasks.svg" },
                { text: this.$i18n.t("menu.newWorkTasks"), to: { name: 'WorkTaskRules', params: { tenantId: this.tenantId } }, icon: "work-task-rules.svg" },
                { text: this.$i18n.t("menu.visits"), to: { name: 'VisitRules', params: { tenantId: this.tenantId } }, icon: "visit-rules.svg" },
                { text: this.$i18n.t("menu.clientsEvaluation"), to: { name: 'ClientsEvaluations', params: { tenantId: this.tenantId } }, icon: "clients-evaluations.svg" },
                { text: this.$i18n.t("menu.statements"), to: { name: 'Statements', params: { tenantId: this.tenantId } }, icon: "statements.svg" },
                { text: "Uzávěrka", to: { name: 'Closings', params: { tenantId: this.tenantId } }, icon: "closings.svg" },
                { text: "Vyúčtování", to: { name: 'Billings', params: { tenantId: this.tenantId } }, icon: "billings.svg" },
                { text: this.$i18n.t("menu.clients"), to: { name: 'Parties', params: { tenantId: this.tenantId } }, icon: "parties.svg" },
                { text: this.$i18n.t("menu.cloud"), to: { name: 'Cloud', params: { tenantId: this.tenantId } }, icon: "cloud.svg" },
                { text: this.$i18n.t("menu.reports"), to: { name: 'ReportProvidedWorkTasks', params: { tenantId: this.tenantId } }, icon: "reports.svg" }
            ];
        }
        else if (tenantUser.accountType == AccountTypeEnum.Worker) {
            return [
                { text: this.$i18n.t("menu.workTasks"), to: { name: 'WorkTasks', params: { tenantId: this.tenantId } }, icon: "tasks.svg" },
                { text: this.$i18n.t("menu.clientsEvaluation"), to: { name: 'ClientsEvaluations', params: { tenantId: this.tenantId } }, icon: "client-evaluation.svg" },
                { text: this.$i18n.t("menu.clients"), to: { name: 'Parties', params: { tenantId: this.tenantId } }, icon: "parties.svg" },
                { text: this.$i18n.t("menu.cloud"), to: { name: 'Cloud', params: { tenantId: this.tenantId } }, icon: "files.svg" }
            ];
        }
        else if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            return [
                { text: this.$i18n.t("menu.workTasks"), to: { name: 'WorkTasks', params: { tenantId: this.tenantId } }, icon: "tasks.svg" }
            ];
        }
        return [];
    }

    @Watch("$route")
    routeChanged () {
        this.detectTenantMenu();
        this.mobileNavCollapsed = false;
    }

    mounted () {
        this.detectTenantMenu();
        if (this.$props.groupId != null)
            this.$data.linkGroupId = this.$props.groupId;
        if (this.tenantId)
            this.selectedTenant = this.tenantId;
        if (this.locale) 
            this.localeInner = this.locale;
    }

    private signout () {
        authStore.dispatch(AuthAction.SignOut);
    }

    private detectTenantMenu () {
        this.tenantMenu = this.$router.currentRoute.meta?.tenant != false;
    }

    private goTo (args : any) {
        args.data.params = { groupId: this.$data.linkGroupId };
        this.$router.push(args.data.to);
    }

    private toUserSettings () {
        this.$router.push({ name: "UserSettings" });
    }

}
